module.exports = __webpack_public_path__ + "static/img/fluoro2.738a3991.png";